'use client';

import { c as _c } from "react/compiler-runtime";
import { closeIcon } from '@/uiIcons/closeIcon.css';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { box } from '@/uiPrimitives/layout/box';
import { pageGrid } from '@/uiPrimitives/layout/pageGrid/pageGrid';
import { placement } from '@/uiPrimitives/layout/placement.css';
import { shelf } from '@/uiPrimitives/layout/shelf';
import { icon } from '@/uiPrimitives/media/icon';
import { useState } from 'react';
import { addClosedBannerToCookie } from './alertBannerCookies';
import { addTestSelector } from '@/globals/testHelpers/testSelector';
import { useIsInertBecauseOfMenu } from '../pageHeader/mainMenu/MainMenu.client';
import { zIndex } from '@/uiPrimitives/layout/zIndex.css';
import { unprintable } from '@/uiPrimitives/base/printable.css';
import { translateInline } from '@/globals/translate/translateInline';
import { alwaysLightColorScheme } from '@/uiPrimitives/color/colorScheme.css';
export const AlertBannerClient = t0 => {
  const $ = _c(24);
  const {
    children,
    alertID
  } = t0;
  const [showing, setShowing] = useState(true);
  const inert = useIsInertBecauseOfMenu();
  if (!showing) {
    return null;
  }
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classes(unprintable, alwaysLightColorScheme, box({
      backgroundColor: "negativeYellow"
    }), pageGrid({}), zIndex({
      zIndex: "brandBar"
    }));
    t2 = addTestSelector("uiAlertBanner");
    t3 = classes(shelf({
      gridTemplateColumns: "minmax(0, 1fr) auto",
      gap: "3 | h1"
    }));
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = classes(placement({
      alignSelf: "end",
      justifySelf: "end"
    }), box({
      backgroundColor: "positiveBlue",
      padding: "-1 | small"
    }));
    t5 = translateInline({
      en: "Close alert",
      nl: "Sluit melding"
    });
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== alertID) {
    t6 = () => {
      addClosedBannerToCookie(alertID);
      setShowing(false);
    };
    $[5] = alertID;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = addTestSelector("uiAlertBannerCloseButton");
    t8 = classes(icon({
      icon: closeIcon,
      inlineSize: "0 | p",
      blockSize: "0 | p"
    }));
    $[7] = t7;
    $[8] = t8;
  } else {
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t8) {
    t9 = <i className={t8} />;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t4 || $[12] !== t5 || $[13] !== t6 || $[14] !== t9) {
    t10 = <button className={t4} aria-label={t5} onClick={t6} {...t7}>{t9}</button>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== children || $[17] !== t10 || $[18] !== t3) {
    t11 = <div className={t3}>{children}{t10}</div>;
    $[16] = children;
    $[17] = t10;
    $[18] = t3;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== inert || $[21] !== t1 || $[22] !== t11) {
    t12 = <aside data-nosnippet={true} inert={inert} className={t1} {...t2}>{t11}</aside>;
    $[20] = inert;
    $[21] = t1;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
};